// extracted by mini-css-extract-plugin
export var sbShowMain = "partnersCarousel-module--sb-show-main--359Qq";
export var partnersCarousel = "partnersCarousel-module--partnersCarousel--1t-ft";
export var photoSliderImg = "partnersCarousel-module--photoSliderImg--2AnHn";
export var carousel = "partnersCarousel-module--carousel--2KYoc";
export var buttonGroup = "partnersCarousel-module--buttonGroup--2Bmef";
export var leftArrow = "partnersCarousel-module--leftArrow--2_Th7";
export var rightArrow = "partnersCarousel-module--rightArrow--3mVcF";
export var item = "partnersCarousel-module--item--1oH23";